<template>
  <v-container>
    <v-card max-width="544" class="mt-4 mx-auto px-4">
      <v-img height="130" contain :src="require('@/assets/logo-notarios.png')"></v-img>
      <v-card-title>Iniciar sesión</v-card-title>
      <v-card-text>
        <v-form lazy-validation ref="form">
          <v-text-field
            label="Usuario"
            v-model="username"
            prepend-icon="mdi-account"
            :rules="[rules.required]"
          />
          <v-text-field
            label="Contraseña"
            v-model="password"
            prepend-icon="mdi-lock-question"
            :rules="[rules.required]"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
          />
        </v-form>
        <p class="red--text" v-if="feedback">{{feedback}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="signIn()" :loading="loading">Entrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import login from "@/firebase/login";
// import ForgotPassword from "./ForgotPassword";

export default {
  name: "Login",
  // components: { ForgotPassword },
  data() {
    return {
      // forgotDialog: false,
      username: "", //"diego@me.com",
      password: "", //"qqqqqq1",
      show: false,
      rules: {
        required: (value) => (value != "" ? true : "Llena el campo."),
      },
      loading: false,
      feedback: null,
    };
  },
  methods: {
    signIn() {
      if (!this.$refs.form.validate()) {
        console.log("errors exist");
        return;
      }
      console.log(this.username, this.password);
      this.loading = true;
      this.feedback = false;
      let email = this.username + "@notarioschihuahua.mx";
      login
        .emailSignIn(email, this.password)
        .then(() => {
          console.log("succes in signin in");
          this.loading = false;
        })
        .catch((error) => {
          console.log("loginError", error);
          this.loading = false;
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          this.feedback = error.message;
          console.log("myError", errorCode, errorMessage);
        });
    },
  },
};
</script>